import { __assign, __values } from "tslib";
/**
 * Utility function to merge favorites API response into a map with document ID as key
 */
export function mergeFavoritesIntoMap(allFilesMap, favoritedFiles) {
    var e_1, _a;
    var updatedFiles = [];
    try {
        for (var favoritedFiles_1 = __values(favoritedFiles), favoritedFiles_1_1 = favoritedFiles_1.next(); !favoritedFiles_1_1.done; favoritedFiles_1_1 = favoritedFiles_1.next()) {
            var file = favoritedFiles_1_1.value;
            var existingFile = allFilesMap.get(file.id);
            if (existingFile && !existingFile.is_pinned) {
                var updatedFile = __assign(__assign({}, file), { is_pinned: true });
                updatedFiles.push(updatedFile);
                allFilesMap.set(file.id, updatedFile);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (favoritedFiles_1_1 && !favoritedFiles_1_1.done && (_a = favoritedFiles_1.return)) _a.call(favoritedFiles_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return updatedFiles;
}
//# sourceMappingURL=mergeFavoritesIntoMap.js.map